// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"Loader_loaderWrapper__2vK1T","loaderContainer":"Loader_loaderContainer__NmpJF"};